import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import {
 groupContentFields,
 groupERGcategories,
 groupPrivacyStatusDesc,
 groupRoles,
} from "../../utils/constants";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../utils/url";
import { whiteLabelStyling } from "../../utils/constants";
import SingleGroupMenu from "./Components/SingleGroupMenu";
import GroupStories from "./Pages/GroupStories";
import GroupPlanning from "./Pages/GroupPlanning";
import GroupEvents from "./Pages/GroupEvents";
import GroupResources from "./Pages/GroupResources";
import GroupAnalytics from "./Pages/GroupAnalytics";
import GroupMembers from "./Pages/GroupMembers";
import GroupSettings from "./Pages/GroupSettings";
import SingleEvent from "./Components/SingleEvent";
import moment from "moment";
import { Modal, ModalBody, Button, ModalFooter, ModalHeader } from "reactstrap";
import CreateStoryForm from "./Components/GroupStory.jsx";
import StoriesContainer from "./SingleGroupStories.jsx";
import { isMobile } from "../../utils/deviceInfo";
import SingleGroupHeaderMobile from "./Components/SingleGroupHeaderMobile";
import { Accordion } from "../dani/Accordion";
import { BiChevronDown } from "react-icons/bi";


class SingleGroup extends Component {
 constructor(props) {
   super(props);
   this.state = {
     name: "",
     privacy: null,
     group: null,
     description: "",
     members: [],
     storyType: null,
     showCreateStoryModal: false,
     topics: [],
     menu: "",
     isSettingsUpdate: false,
     stories_url: ``,
     currentGroupJoinedAnounymously: false,
   };
 }
 componentWillUnmount() {
   this.props.updateNavBar({
     backButtonData: {
       show: false,
       currentPageType: "",
     },
   });
 }


 updateDataAfterAnonymousToggle = () => {
   const { group } = this.state;
   if (group) {
     let payload = {
       groupId: group._id,
       modelName: "Users",
       noLoader: true,
       groupDoc: group,
     };


     let that = this;
     axios
       .all([
         axios.post(url.groupUserRole, { groupId: group._id, noLoader: true }),
         axios.post(url.getSingleGroupItems, { ...payload, noLoader: true }),
       ])
       .then(
         axios.spread(async function(userRole, group_members) {
           let { role, joinedAnonymously } = userRole.data.data.currentGroup;
           that.setState({
             members: group_members.data.data,
             currentGroupJoinedAnounymously: joinedAnonymously,
           });
         })
       );
   }
 };
 
 componentDidMount() {
   let { id } = this.props.match.params;
   let that = this,
     resp;
   // groupUserRole
   this.props.updateNavBar({
     backButtonData: {
       show: true,
       currentPageType: "GROUP_DETAILS",
     },
   });
   const { organizationId } = this.props.user.profile;
   axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
     const payload = data.data;
     that.props.orgChangeSuccess(payload);
   });
   axios
     .all([
       axios.post(url.groupUserRole, { groupId: id, noLoader: true }),
       axios.post(url.showGroup, { _id: id, noLoader: true }),
     ])
     .then(
       axios.spread(async function(userRole, groupDoc) {
         let { role, joinedAnonymously } = userRole.data.data.currentGroup;
         let group = groupDoc.data.data;


         // console.log('userRole---- ', userRole.data.data)


         if (group && group != null) {
           let payload = {
             groupId: group._id,
             modelName: "Users",
             noLoader: true,
             groupDoc: group,
           };


           let group_members = await axios.post(
             url.getSingleGroupItems,
             payload
           );


           that.setState({
             name: group.name,
             group,
             privacy: group.privacy,
             description: group.description,
             members: group_members.data.data,
             planning: group.planning,
             charts: group.charts,
             tools: group.tools,
             currentRole: role,
             stories_url: `/home/groups/${that.props.user.profile.organizationId._id}/view/${group._id}`,
             currentGroupJoinedAnounymously: joinedAnonymously,
           });


           that.getUrlMenu(group);
           that.getTopics();
         } else {
           that.redirectBack();
         }
       })
     );
 }


 updateCurrentRole = (newRole, userId) => {
   let { user } = this.props;
   const members = [...this.state.members];
   // let {groups}=this.props.user.profile.groups
   const memIndex = members.findIndex((x) => x.o_id == userId);
   if (memIndex >= 0) {
     members[memIndex].role = newRole;
     this.setState({ members: members });


     if (userId == user.profile._id) {
       this.setState({
         currentRole: newRole,
       });
     }
   } else {
     this.setState({ currentRole: newRole });
   }
 };


 redirectBack = () => {
   let { organizationId } = this.props.user.profile;
   this.props.history.push({
     pathname: `/home/groups/${organizationId._id}/discover`,
     state: { redirect_msg: "ARCHIVED" },
   });
 };


 getUrlMenu = (group) => {
   let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${group._id}`;
   let current = this.props.location.pathname;
   let res;


   if (current == url) {
     res = "S";
   } else if (current == url + "/planning") {
     res = "P";
   } else if (current == url + "/analytics") {
     res = "A";
   } else if (current == url + "/resources") {
     res = "R";
   } else if (current == url + "/events") {
     res = "E";
   } else if (current == url + "/members") {
     res = "M";
   }


   let { pathname } = this.props.location;


   if (
     pathname ==
     `/home/groups/${this.props.user.profile.organizationId._id}/settings/${group._id}`
   ) {
     res = 0;
   }


   this.highlightMenu(res);
 };


 highlightMenu = (val) => {
   this.setState({ menu: val });
 };


 createMarkup = (input) => {
   return { __html: `<div>${input}</div>` };
 };


 changeGroupState = (value) => {
   let obj = { ...this.state, ...value };
   this.setState(obj);
 };


 handleInvitedUsers = (mLength) => {
   this.setState({ memberCount: mLength + 1 });
 };


 getInitials = (user) => {
   let firstName =
     user.firstName && user.firstName.length > 0 ? user.firstName : "N";
   let lastName =
     user.lastName && user.lastName.length > 0 ? user.lastName : "N";
   return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
 };


 getTopics = () => {
   if (!this.props.user) return;
   let orgId = this.props.user.profile.organizationId._id;


   axios.get(url.getTopics(orgId)).then(({ data }) => {
     // console.log("data---", data.data)
     let topics = data.data;
     this.setState({
       topics: [...topics],
     });
   });
 };


 toggleCreateStory = (e) => {
   // console.log(e)
   this.setState({ showCreateStoryModal: true, storyType: "Create Story" });
 };


 goToPage = (menu) => {
   let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${this.state.group._id}`;
   // this.props.history.push(`/home/groups/${this.props.user.profile.organizationId._id}/view/${this.state.group._id}`)
   // menu
   if (menu == "P") {
     this.props.history.push(url + "/planning");
   } else if (menu == "A") {
     this.props.history.push(url + "/analytics");
   } else if (menu == "R") {
     this.props.history.push(url + "/resources");
   } else if (menu == "E") {
     this.props.history.push(url + "/events");
   } else if (menu == "M") {
     this.props.history.push(url + "/members");
   } else if (menu == "S") {
     this.props.history.push(url);
   } else if (menu == "ST") {
     this.props.history.push(url + "/settings");
   }
   this.highlightMenu(menu);
 };


 closeModal = () => {
   this.setState({ showCreateStoryModal: false });
 };


 removeMember = (userId) => {
   let { members } = this.state;
   let result = members.filter((e) => e.o_id != userId);
   // console.log(result.length,'----removeMember---- ', result)
   this.setState({ members: result });
   // this.props.changeMemberLength(result.length, '-')
 };


 updateGroupSettings = (newObj) => {
   let { group } = this.state;
   let result = { ...group, ...newObj };
   this.setState({
     group: result,
     isSettingsUpdate: !this.state.isSettingsUpdate,
   });
 };


 renderGroupView = () => {
   let { menu, group, currentRole } = this.state;
   // console.log('renderGrp --- ', currentRole)
   if (group && group._id) {
     let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${group._id}`;
     let current = this.props.location.pathname;


     if (current == url) {
       return (
         <GroupStories
           {...this.state}
           currentRole={currentRole}
           goToSettings={this.goToPage}
           highlightMenu={this.highlightMenu}
         />
       );
     } else if (current == url + "/planning") {
       return (
         <GroupPlanning
           {...this.state}
           currentRole={currentRole}
           highlightMenu={this.highlightMenu}
         />
       );
     } else if (current == url + "/analytics") {
       return (
         <GroupAnalytics
           {...this.state}
           currentRole={currentRole}
           highlightMenu={this.highlightMenu}
         />
       );
     } else if (current == url + "/resources") {
       return (
         <GroupResources
           {...this.state}
           currentRole={currentRole}
           highlightMenu={this.highlightMenu}
         />
       );
     } else if (current == url + "/events") {
       return (
         <GroupEvents
           {...this.state}
           group={group}
           currentRole={currentRole}
           highlightMenu={this.highlightMenu}
         />
       );
     } else if (current == url + "/members") {
       return (
         <GroupMembers
           {...this.state}
           currentRole={currentRole}
           removeMember={this.removeMember}
           highlightMenu={this.highlightMenu}
           updateCurrentRole={this.updateCurrentRole}
         />
       );
     } else if (current == url + "/settings") {
       return (
         <GroupSettings
           updateGroupSettings={this.updateGroupSettings}
           {...this.state}
           currentRole={currentRole}
           highlightMenu={this.highlightMenu}
         />
       );
     }
   }
 };


 updateGroupMembers = (new_mem) => {
   if (new_mem && new_mem.length > 0) {
     let { members } = this.state;
     let result = [...new_mem, ...members];
     this.setState({ members: result });
   }
 };
 updateGroupMembersData = (new_mem) => {

   if (new_mem && new_mem.length > 0) {
    // alert(JSON.stringify(new_mem.map(x=>({r:x.role,n:x.lastName}))))
     let result = [...new_mem];
     this.setState({ members: result });
   }
 };


 grpHomePage = () => {
   let { organizationId } = this.props.user.profile;
   let url = `/home/groups/${organizationId._id}/view/${this.state.group._id}`;
   this.props.history.push(url);
 };


 changeGroupRole = (val) => {
   this.setState({ currentRole: val });
   let { user } = this.props;
   // let {groups}=this.props.user.profile.groups
   if (val != -1) {
     let result = {
       ...user.profile,
       o_id: user.profile._id,
       role: 1000,
     };
     this.updateGroupMembers([result]);
   } else {
     this.setState((prevState) => ({
       members: prevState.members.filter(
         (e) => e.o_id != user.profile._id.toString()
       ),
     }));
   }
 };


 checkValidation = (org, module) => {
   let { selectModule } = org;


   if (selectModule) {
     if (module && module.status) {
       if (
         module &&
         (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
       ) {
         return true;
       } else {
         return false;
       }
     } else {
       return false;
     }
   } else {
     if (
       module &&
       (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
     ) {
       console.log("262");
       return true;
     } else {
       console.log("265");
       return false;
     }
   }
 };


 renderContent = () => {
   let { members, currentRole, group, stories_url, menu } = this.state;
   let { privacy } = group;
   let { history, user } = this.props,
     url = "";
   let current =
     history && history.location && history.location.pathname
       ? history.location.pathname
       : "";


   // console.log('currentRole -- ', currentRole)
   return (
     <span>
       <div className="groups-desktop-sidebar">
         <SingleGroupMenu
           updateGroupSettings={this.updateGroupSettings}
           currentRole={currentRole}
           {...this.state}
           changeGroupRole={this.changeGroupRole}
           members={members}
           group={this.state.group}
           goToSettings={this.goToPage}
           updateGroupMembers={this.updateGroupMembers}
           updateGroupMembersData={this.updateGroupMembersData}
           handleInvitedUsers={this.handleInvitedUsers}
           changePrivacy={this.changeGroupState}
           changeGroupName={this.changeGroupState}
           currentGroupJoinedAnounymously={
             this.state.currentGroupJoinedAnounymously
           }
           updateDataAfterAnonymousToggle={this.updateDataAfterAnonymousToggle}
         />
       </div>


       <div className="grp_single_page_container">
         {isMobile && (
           <SingleGroupHeaderMobile
             updateGroupSettings={this.updateGroupSettings}
             currentRole={currentRole}
             {...this.state}
             changeGroupRole={this.changeGroupRole}
             members={members}
             menu={menu}
             group={this.state.group}
             goToSettings={this.goToPage}
             stories_url={stories_url}
             updateGroupMembers={this.updateGroupMembers}
             handleInvitedUsers={this.handleInvitedUsers}
             changePrivacy={this.changeGroupState}
             changeGroupName={this.changeGroupState}
           />
         )}


         <div className="grp_single_page_details">
           {current == url ? (
             <span
               className="grp_page_menu_items_settings"
               style={whiteLabelStyling(
                 ["textDecorationColor"],
                 this.props.user.profile.organizationId
               )}
             >
               <span
                 className="grp_page_menu_item_back_btn"
                 onClick={() => this.grpHomePage()}
               >
                 Back
               </span>
               Group Settings
             </span>
           ) : (
             <span className="grp_items_mobile_wrapper">
               {isMobile && group.groupOwner && group.groupOwner._id == user.profile._id && (
                 <span
                   className={`grp_page_menu_items ${
                     menu == "ST" ? "grp_menu_item_selected" : ""
                   }`}
                   onClick={() => this.goToPage("ST")}
                   style={whiteLabelStyling(
                     ["textDecorationColor"],
                     this.props.user.profile.organizationId,
                     menu != "ST"
                   )}
                 >
                   Settings
                 </span>
               )}


               <span
                 className={`grp_page_menu_items ${
                   menu == "S" ? "grp_menu_item_selected" : ""
                 }`}
                 onClick={() => this.goToPage("S")}
                 style={whiteLabelStyling(
                   ["textDecorationColor"],
                   this.props.user.profile.organizationId,
                   menu != "S"
                 )}
               >
                 Posts
               </span>


               <span
                 className={`grp_page_menu_items ${
                   menu == "M" ? "grp_menu_item_selected" : ""
                 }`}
                 onClick={() => this.goToPage("M")}
                 style={whiteLabelStyling(
                   ["textDecorationColor"],
                   this.props.user.profile.organizationId,
                   menu != "M"
                 )}
               >
                 Members
               </span>


              
                 <span
                   className={`grp_page_menu_items ${
                     menu == "E" ? "grp_menu_item_selected" : ""
                   }`}
                   onClick={() => this.goToPage("E")}
                   style={whiteLabelStyling(
                     ["textDecorationColor"],
                     this.props.user.profile.organizationId,
                     menu != "E"
                   )}
                 >
                   Events
                 </span>
             


               {this.checkValidation(
                 this.props.user.profile.organizationId,
                 this.props.user.profile.organizationId.isPlanning
               ) ? (
                 <span
                   className={`grp_page_menu_items ${
                     menu == "P" ? "grp_menu_item_selected" : ""
                   }`}
                   onClick={() => this.goToPage("P")}
                   style={whiteLabelStyling(
                     ["textDecorationColor"],
                     this.props.user.profile.organizationId,
                     menu != "P"
                   )}
                 >
                   Planning
                 </span>
               ) : (
                 <small className={`grp_page_menu_items ui-disabled`}>
                   Planning (must upgrade)
                 </small>
               )}


               {this.checkValidation(
                 this.props.user.profile.organizationId,
                 this.props.user.profile.organizationId.isAnalytics
               ) ? (
                 <span
                   className={`grp_page_menu_items ${
                     menu == "A" ? "grp_menu_item_selected" : ""
                   }`}
                   onClick={() => this.goToPage("A")}
                   style={whiteLabelStyling(
                     ["textDecorationColor"],
                     this.props.user.profile.organizationId,
                     menu != "A"
                   )}
                 >
                   Analytics
                 </span>
               ) : (
                 <small className={`grp_page_menu_items ui-disabled`}>
                   Analytics (must upgrade)
                 </small>
               )}


               {this.checkValidation(
                 this.props.user.profile.organizationId,
                 this.props.user.profile.organizationId.isToolkit
               ) ? (
                 <span
                   className={`grp_page_menu_items`}
                   onClick={() => this.goToPage("R")}
                   style={whiteLabelStyling(
                     ["textDecorationColor"],
                     this.props.user.profile.organizationId,
                     menu != "R"
                   )}
                 >
                   Resources
                 </span>
               ) : (
                 <small
                   className={`grp_page_menu_items ui-disabled`}
                 >
                   Resources (must upgrade)
                 </small>
               )}
             </span>
           )}
         </div>
       </div>
       


       <div
         className={`grp_single_detail_page_container ${
           menu == "P" ? "grp_single_detail_page_planning_margin" : ""
         } ${menu == "M" ? "grp_single_detail_page_members_margin" : ""} ${
           menu == "A" ? "grp_single_detail_page_analytics_margin" : ""
         } ${
           menu == "R" || menu == "E"
             ? "grp_single_page_resources_margin_left"
             : ""
         }`}
       >
         <div
           className={`grp_single_page_details_container ${
             menu == "R" || menu == "E"
               ? "grp_single_page_resources_display"
               : ""
           } ${menu == 0 ? "grp_single_page_settings_margin" : ""}`}
         >
           {this.renderGroupView()}
         </div>
       </div>


       {this.props.location.pathname == stories_url ? (
         <span className="grp_single_detail_page_container_privacy_section">
           <div className="grp_single_page_privacy_status_info">
             <Accordion open={1}>
               <Accordion.Item noCard>
              <Accordion.Header noCard>
              <span className="grp_create_page_privacy_status_details title">
              <div className="d-flex justify-content-between">
                About  <BiChevronDown />
                  </div>  
             </span>
                </Accordion.Header>
                <Accordion.Body noCard>
                <span className="grp_create_page_privacy_status_details description">
               {group.description}
             </span>
             {group.privacy ? (
               <span className="grp_create_page_privacy_status_details option">
                 {groupContentFields(privacy).name}
                 <span> {groupContentFields(privacy).description} </span>
                 <span> {groupContentFields(privacy).permission} </span>
               </span> 
             ) : (
               <span>
                 {groupPrivacyStatusDesc.map((e, idx) => {
                   return (
                     <span
                       className="grp_create_page_privacy_status_details option"
                       key={idx + e.id}
                     >
                       {e.name}
                       <span> {e.description} </span>
                     </span>
                   );
                 })}
               </span>
             )}
                </Accordion.Body>
            
               </Accordion.Item>

               </Accordion>
               

           
             
           </div>


           {(group && group.categories.length > 0) ||
           (group &&
             group.groupOwner &&
             group.groupOwner._id == user.profile._id) ? (
              <div className="grp_single_page_grp_categories grp_right_side_menu_padding">
              <Accordion open={1}>
              <Accordion.Item noCard>
                <Accordion.Header noCard>
                <span className="grp_create_page_privacy_status_details title">
                <div className="d-flex justify-content-between">
                Categories  <BiChevronDown />
                  </div>   
               </span>
                </Accordion.Header>
                <Accordion.Body>
                <span className="grp_create_page_privacy_status_details">
                 {group && group.categories.length > 0 ? (
                   group.categories.map((e, idx) => {
                     return (
                       <div
                         className="grp_story_container"
                         style={{
                           paddingRight:
                             e._id == "template_other_01" ? "0px" : "",
                         }}
                         key={idx}
                       >
                         <div
                           className="grp_story_template"
                           style={{
                             backgroundColor: groupERGcategories.filter(
                               (g) => g.id == e.id
                             )[0].color,
                             border: groupERGcategories.filter(
                               (g) => g.id == e.id
                             )[0].border,
                           }}
                         >
                           <img src={e.image} className="grp_template_image" />
                           {e.name}
                         </div>
                       </div>
                     );
                   })
                 ) : (
                   <span className="go_to_grp_settings">
                     Please go to{" "}
                     <span
                       className="go_to_grp_settings_btn"
                       onClick={() => this.goToPage("ST")}
                     >
                       Group Settings
                     </span>{" "}
                     to select categories.
                   </span>
                 )}
               </span>
                </Accordion.Body>
             </Accordion.Item>

              </Accordion>
              </div>
               
              
         
           ) : null}


           {group && group._id ? (
             <div className="grp_single_page_grp_categories">
               <SingleEvent group={this.state.group} />
             </div>
           ) : null}
         </span>
       ) : menu == "M" ? (
         <span className="grp_single_detail_page_container_rmenu_members members-mobile-hide-info">
           <div className="grp_single_page_privacy_status_info">
             <span className="grp_single_detail_page_container_rmenu_members_title">
               Group Member Roles
             </span>


             {groupRoles.map((e) => {
               if (e.isHidden != true) {
                 return (
                   <div className="grp_single_detail_page_container_rmenu_members_itm">
                     <span className="grp_single_detail_page_container_rmenu_members_label">
                       {e.label}
                     </span>
                     <span className="grp_single_detail_page_container_rmenu_members_description">
                       {e.description}
                     </span>
                   </div>
                 );
               }
             })}
           </div>
         </span>
       ) : null}
     </span>
   );
 };


 render() {
   let {
     members,
     currentRole,
     group,
     stories_url,
     menu,
     topics,
     storyType,
     showCreateStoryModal,
   } = this.state;


   let { history, user } = this.props,
     url = "";


   let current =
     history && history.location && history.location.pathname
       ? history.location.pathname
       : "";


   if (user && user.profile.organizationId && group && group._id) {
     url =
       group && group._id
         ? `/home/groups/${user.profile.organizationId._id}/view/${group._id}/settings`
         : "";
   }


   return (
     <span className="grp_single_page_sg_component_container">
       {group && Object.keys(group).length > 0 ? this.renderContent() : null}


       {group && group.name && currentRole >= 0 ? (
         <CreateStoryForm
           group={group}
           topics={topics}
           closeModal={this.closeModal}
           storyType={storyType}
           showCreateStoryModal={showCreateStoryModal}
           currentGroupJoinedAnounymously={
             this.state.currentGroupJoinedAnounymously
           }
           //  topics={this.state.topics}
           // onStoryPublish={this.onStoryPublish.bind(this)}
           // onStoryCancel={this.closeCreateStoryModal.bind(this)}
         />
       ) : null}
     </span>
   );
 }
}


const mapStateToProps = (state) => {
 return {
   user: state.user,
   kpiMaster: state.kpiMaster,
   mappingMaster: state.mappingMaster,
   reports: state.reports,
 };
};


const mapDispatchToProps = (dispatch) => {
 return {
   onKpiMasterListFetched: (data) =>
     dispatch(actionCreators.storeKpiMaster(data)),
   onMappingMasterListFetched: (data) =>
     dispatch(actionCreators.storeMappingMaster(data)),
   onProfileUpdate: (data) =>
     dispatch(actionCreators.updateProfileInfoSuccess(data)),
   updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
   updateReport: (dashboard) =>
     dispatch(actionCreators.updateReport(dashboard)),
   orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
 };
};


export default withRouter(
 connect(mapStateToProps, mapDispatchToProps)(Loading(SingleGroup, axios))
);
